import { renderLinearGradient } from './linear.js';
import { renderRadialGradient } from './radial.js';
import { renderConicGradient } from './conic.js';
import { renderRepeatingLinearGradient } from './repeating-linear.js';
import { renderRepeatingRadialGradient } from './repeating-radial.js';
import { renderRepeatingConicGradient } from './repeating-conic.js';

/**
 * Map of gradient types to their renderer functions
 */
const renderers = {
  'linear-gradient': renderLinearGradient,
  'radial-gradient': renderRadialGradient,
  'conic-gradient': renderConicGradient,
  'repeating-linear-gradient': renderRepeatingLinearGradient,
  'repeating-radial-gradient': renderRepeatingRadialGradient,
  'repeating-conic-gradient': renderRepeatingConicGradient,
};

/**
 * Render a gradient based on its type
 * @param {CanvasRenderingContext2D} context - Canvas context
 * @param {Object} gradientDef - Gradient definition from parser
 * @param {Object} bounds - Bounding box { x, y, w, h }
 * @param {Function} [render] - Optional render callback
 * @returns {CanvasGradient|null} Canvas gradient object or null
 */
export function renderGradient(context, gradientDef, bounds, render) {
  if (!bounds.w || !bounds.h) return null;

  const renderer = renderers[gradientDef.type];

  if (!renderer) {
    // Unsupported gradient type
    return null;
  }

  const gradient = renderer(context, gradientDef, bounds);

  if (render && gradient) {
    context.fillStyle = gradient;
    render(gradient);
  }

  return gradient;
}

export {
  renderLinearGradient,
  renderRadialGradient,
  renderConicGradient,
  renderRepeatingLinearGradient,
  renderRepeatingRadialGradient,
  renderRepeatingConicGradient,
};
